import { Button, Modal } from 'antd'
import React from 'react'

const CustomModal = (props) => {
    const { open, handleOk, confirmLoading, handleCancel, children, title, action = '' } = props
    return (
        <Modal
            centered
            title={title}
            open={open}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            footer={action === 'view' ? null : [
                <Button key="back" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" loading={confirmLoading} onClick={handleOk}>
                    Save
                </Button>,

            ]}
        >
            {children}
        </Modal>
    )
}

export default CustomModal